import { SvgIcon } from '@mui/material';

interface TrashProps {
  color?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

export default function Trash({ color = `white`, style = {}, onClick }: TrashProps) {
  return (
    <SvgIcon viewBox="0 0 16.64 20.02" style={{ width: `24px`, ...style }} onClick={onClick}>
      <g>
        <path
          fill={color}
          d="m15.83,3.3h-1.4s0,0,0,0h-2.82v-1.33c0-.99-.81-1.79-1.79-1.79h-1.47s0,0-.01,0h-1.48c-.99,0-1.79.81-1.79,1.8v1.32h-2.82s0,0,0,0H.81c-.35.01-.64.3-.65.65-.01.37.28.69.65.7h.73v13.02c0,1.2.97,2.17,2.17,2.17h9.21c1.2,0,2.17-.97,2.17-2.17V4.65h.73c.35-.01.64-.3.65-.65.01-.37-.28-.69-.65-.7ZM6.4,1.97c0-.24.2-.44.44-.44h1.47s.01,0,.02,0h1.48c.24,0,.44.2.44.44v1.32h-3.84v-1.33Zm7.34,15.7h0c0,.45-.37.81-.82.81H3.72c-.45,0-.81-.36-.82-.81V4.65h10.84v13.02Z"
        />
        <path
          fill={color}
          d="m7.37,11.56l-1.65,1.65c-.13.13-.2.3-.2.48,0,.37.3.68.68.68.18,0,.35-.07.48-.2l1.65-1.65,1.65,1.65c.13.13.3.2.48.2h0c.18,0,.35-.07.48-.2.27-.26.27-.69,0-.96l-1.65-1.65,1.65-1.65c.26-.26.26-.69,0-.96s-.69-.26-.96,0l-1.65,1.65-1.65-1.65c-.26-.26-.69-.26-.96,0-.26.26-.26.69,0,.96l1.65,1.65Z"
        />
      </g>
    </SvgIcon>
  );
}
